"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useState, useMemo, useEffect } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { useLocalStorage } from "../../../hooks/useLocalStorage/index.js";
const MSALProviderContext = createContext(null);
const MSALContextProviderClient = (props) => {
  const [msalInstance, setMsalInstance] = useState(null);
  const [msalInstanceLoaded, setMsalInstanceLoaded] = useState(false);
  const {
    locale,
    msalConfig,
    msalEnabledFeatureFlag,
    children,
    site,
    redirectUri = ""
  } = props;
  const [hasMsalLocalStorage] = useLocalStorage("msal_temp", void 0);
  const isMsalEnabled = msalEnabledFeatureFlag || !!hasMsalLocalStorage;
  const baseMsalConfig = useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    if (!msalConfig || !isMsalEnabled) return {};
    return {
      configUrl: (_b = (_a = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _a[site]) == null ? void 0 : _b.configUrl,
      msalConfig: {
        auth: {
          clientId: (_d = (_c = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _c[site]) == null ? void 0 : _d.clientId,
          authority: (_f = (_e = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _e[site]) == null ? void 0 : _f.authority,
          knownAuthorities: [
            (_h = (_g = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _g[site]) == null ? void 0 : _h.knownAuthorities
          ],
          redirectUri: redirectUri !== "" ? redirectUri : (_j = (_i = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _i[site]) == null ? void 0 : _j.redirectUri,
          postLogoutRedirectUri: typeof window !== "undefined" ? window.location.origin : "",
          clientName: (_l = (_k = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _k[site]) == null ? void 0 : _l.site,
          tc: (_n = (_m = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _m[site]) == null ? void 0 : _n.tc
        },
        cache: {
          cacheLocation: (_p = (_o = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _o[site]) == null ? void 0 : _p.cacheLocation,
          // Use local storage to maintain session across page refreshes
          storeAuthStateInCookie: (_r = (_q = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _q[site]) == null ? void 0 : _r.storeAuthStateInCookie
        },
        system: {
          tokenRenewalOffsetSeconds: (_t = (_s = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _s[site]) == null ? void 0 : _t.tokenRenewalOffsetSeconds
        },
        wcs: {
          subscriptionKey: (_v = (_u = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _u[site]) == null ? void 0 : _v.wcsSubscriptionKey
        }
      },
      extraQueryParameters: {
        ui_locales: locale ? locale : "en-US"
      },
      editEmailAuthority: (_x = (_w = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _w[site]) == null ? void 0 : _x.editEmailAuthority,
      editPasswordAuthority: (_z = (_y = msalConfig == null ? void 0 : msalConfig.custom) == null ? void 0 : _y[site]) == null ? void 0 : _z.editPasswordAuthority
    };
  }, [isMsalEnabled, msalConfig, locale, site, redirectUri]);
  useEffect(() => {
    if (baseMsalConfig == null ? void 0 : baseMsalConfig.msalConfig) {
      const updatedMsalInstance = new PublicClientApplication(
        baseMsalConfig.msalConfig
      );
      setMsalInstance(updatedMsalInstance);
    } else if (msalEnabledFeatureFlag && (!baseMsalConfig || Object.keys(baseMsalConfig).length === 0)) {
      console.error("MSAL Provider Client:: MSAL Config is missing");
    }
  }, [baseMsalConfig, msalEnabledFeatureFlag]);
  useEffect(() => {
    if (msalInstance) {
      msalInstance.initialize().then(() => {
        setMsalInstanceLoaded(true);
      });
    }
  }, [msalInstance]);
  return /* @__PURE__ */ jsx(
    MSALProviderContext.Provider,
    {
      value: {
        baseMsalConfig,
        msalEnabledFeatureFlag: isMsalEnabled,
        msalInstance,
        msalInstanceLoaded
      },
      children
    }
  );
};
export {
  MSALContextProviderClient,
  MSALProviderContext
};
